module.exports = __webpack_public_path__ + "static/17-d185344a02df4fe0873dd66c6ea748e9.png";